export const SEARCH_SHIPMENT_SUCCESS = "SEARCH_SHIPMENT_SUCCESS";
export const SEARCH_SHIPMENT_REQUEST = "SEARCH_SHIPMENT_REQUEST";
export const SEARCH_SHIPMENT_FAILURE = "SEARCH_SHIPMENT_FAILURE";
export const SEARCH_SHIPMENT_REST = "SEARCH_SHIPMENT_REST";
export const searchShipmentSuccess = (payload) => ({
    type: SEARCH_SHIPMENT_SUCCESS,
    payload,
});
export const searchShipmentRequest = (payload) => ({
    type: SEARCH_SHIPMENT_REQUEST,
    payload,
});
export const searchShipmentFailure = (payload) => ({
    type: SEARCH_SHIPMENT_FAILURE,
    payload,
});
export const searchShipmentRest = () => ({
    type: SEARCH_SHIPMENT_REST,
});
